import React from "react";
import { Radio, Checkbox, Input, InputNumber, Form } from "antd";
// import './Answer.css'; // Import the CSS file for styling
import AnswerTypes from "../../utils/enums/answerTypes";
import { QuestionnaireContext } from "./QuestionnarieContext";
const AnswerRender = ({ answerType, answer, question }) => {
  //Get the state of the component Questionnaire
  const { questionsState, onChangeQuestion, clear } =
    React.useContext(QuestionnaireContext);

  //Renders the answer selecteds in the state of the component Questionnaire
  const [selectedOption, setSelectedOption] = React.useState("");
  const [selectedCheckboxes, setSelectedCheckboxes] = React.useState([]);
  const [inputValue, setInputValue] = React.useState("");
  const [inputValueNumber, setInputValueNumber] = React.useState("");

  //Set answer for return in model
  const [answerSelecteds, setAnswerSelecteds] = React.useState([]);

  //Set the answerSelecteds in the state of the component Answer
  const handleOptionChange = (event) => {
    setSelectedOption(event.target.value);
    setAnswerSelecteds(event.target.value);
  };

  const handleCheckboxChange = (value) => {
    setSelectedCheckboxes(value);
    setAnswerSelecteds(value);
  };

  const handleInputChange = (event, answer) => {
    const value = event.target?.value;
    if (/^\d*$/.test(value)) {
      setInputValue(value);
      setAnswerSelecteds(answer);
    }
  };
  const handleInputChangeNumber = (value, answer) => {
    if (/^\d*$/.test(value)) {
      setInputValueNumber(value);
      setAnswerSelecteds(answer);
    }
  };
  const handleStepInputChangeNumber = (value, answer) => {
    if (/^\d*$/.test(value)) {
      setInputValueNumber(value, answer);
      setAnswerSelecteds(answer);
    }
  };
  const clearAnswer = () => {
    setSelectedOption("");
    setSelectedCheckboxes([]);
    setInputValue("");
    setInputValueNumber("");
  };

  //Save the answer selecteds in the state of the component Questionnaire
  const saveAnswer = (answers) => {
    onChangeQuestion({ question, answers });
  };
  React.useEffect(() => {
    if (clear != undefined && clear() === true) {
      clearAnswer();
    }
  }, [false]);

  //Fill the answer selecteds in the state of the component Questionnaire
  React.useEffect(() => {
    const questionState = questionsState.filter(
      (questionState) => questionState.question.key === question.key
    );
    if (questionState.length > 0) {
      const answerSelecteds = questionState[0].answerSelecteds;
      if (answerSelecteds !== undefined) {
        switch (answerType) {
          case AnswerTypes.MultipleSelection:
            setSelectedCheckboxes(answerSelecteds.options);
            break;
          case AnswerTypes.TextEntry:
            setInputValue(answerSelecteds.text);
            break;
          case AnswerTypes.NumericEntry:
            if (
              answerSelecteds != undefined &&
              answerSelecteds.text !== undefined &&
              answerSelecteds.text !== null &&
              answerSelecteds.text !== "" &&
              /^\d*$/.test(answerSelecteds.text)
            ) {
              setInputValueNumber(parseInt(answerSelecteds.text));
            } else {
              setInputValueNumber(0);
            }
            break;
          default:
          case AnswerTypes.SingleSelection:
            setSelectedOption(answerSelecteds.value);
            break;
        }
      }
    }

    if (question.readOnly && question.readOnly == true) {
      setInputValueNumber(answer[0].value);
    }
  }, []);
  //Save the answer selecteds in the state of the component Questionnaire
  React.useEffect(() => {
    switch (answerType) {
      case AnswerTypes.TextEntry:
        saveAnswer({
          ...answerSelecteds,
          text: inputValue,
        });
        break;
      case AnswerTypes.NumericEntry:
        saveAnswer({
          ...answerSelecteds,
          text: inputValueNumber.toString(),
        });
        break;
      case AnswerTypes.MultipleSelection:
        let values = selectedCheckboxes?.map((checkbox) => checkbox.id);
        saveAnswer({
          ...answerSelecteds,
          options: values,//selectedCheckboxes,
        });
        break;
      default:
        saveAnswer({
          ...answerSelecteds,
          value: selectedOption?.id,
        });
        break;
    }
  }, [selectedOption, selectedCheckboxes, inputValue, inputValueNumber]);

  const renderAnswerOther = () => {
    return (
      <div className="answer-container">
        <Input placeholder="Otro" />
      </div>
    );
  };
  // ChoiceText = is a checkbox used for the answer Other (Otro) and show the input text for the user explain the answer
  // In the array of answer we can have type answer for default is a option, but if we have a answer with type answer we need to show a input text for the user explain the answer

  // The type of answer has type property: text, number, ChoiceText
  // The property prefix is used for the prefix of the input text when the answer is a number or input or ChoiceText

  // AnswerType is: Single (Input or another elements), multipleChoices (Checkbox), Options (Radio)
  const renderAnswer = () => {
    switch (answerType) {
      case AnswerTypes.MultipleSelection:
        return (
          <div className="answer-container">
            <Checkbox.Group
              style={{ display: "grid", gridTemplateColumns: "repeat(3, 1fr)" }}
              value={selectedCheckboxes}
              onChange={handleCheckboxChange}
            >
              {answer.map((checkbox, index) => {
                return (
                  <Checkbox
                    key={checkbox.id + "-" + question.key + "-" + index}
                    value={checkbox}
                    className="mt-1"
                  >
                    {checkbox.answer}
                  </Checkbox>
                );
              })}
            </Checkbox.Group>
          </div>
        );
      case AnswerTypes.TextEntry:
        return (
          <div className="answer-container row">
            {answer.map((answer, index) => (
              <div
                key={answer.id + "-" + question.key + "-" + index}
                className="col col-xs-6 col-md 4 answer-item"
              >
                <Input
                  type="text"
                  value={inputValue}
                  addonBefore={answer.answerSufix}
                  addonAfter={answer.answerPrefix}
                  onChange={(e) => handleInputChange(e, answer)}
                />
              </div>
            ))}
          </div>
        );
      case AnswerTypes.NumericEntry:
        return (
          <div className="answer-container row">
            {answer.map((answer) => (
              <div
                key={answer.id + "-" + question.key}
                className="col col-xs-6 col-md 4 answer-item"
              >
                <InputNumber
                  min={0}
                  value={inputValueNumber}
                  className="mt-1"
                  addonBefore={answer.answerSufix}
                  addonAfter={answer.answerPrefix}
                  onChange={(e) => handleInputChangeNumber(e, answer)}
                  onStep={handleStepInputChangeNumber}
                />
              </div>
            ))}
          </div>
        );
      default:
      case AnswerTypes.SingleSelection:
        return (
          <div className="answer-container mt-1">
            <Radio.Group
              style={{ display: "grid", gridTemplateColumns: "repeat(3, 1fr)" }}
              value={selectedOption}
              onChange={handleOptionChange}
            >
              {answer.map((option, index) => (
                <Radio
                  key={option.id + "-" + question.key + "-" + index}
                  value={option}
                  className="mt-1"
                >
                  {option.answer}
                </Radio>
              ))}
            </Radio.Group>
          </div>
        );
    }
  };

  return (
    <div>
      {question.readOnly != undefined && question.readOnly === true ? (
        answer[0].value
      ) : (
        <Form.Item
          name={"fi_" + question.key}
          rules={[{ required: true, message: "Es requerido" }]}
        >
          {renderAnswer()}
        </Form.Item>
      )}
    </div>
  );
};

export default AnswerRender;
